import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    getb2bjson (date,com) {
        return Api().get('bills/getgstb2b/'+date+'/'+com)
    },

    getgstdata (startdate,enddate,con) {
        console.log("Startdate "+startdate)
        console.log("End date "+enddate)
        return Api().get('bills/getgstdata/'+startdate+'/'+enddate+'/'+con)
    },
    getcreditnotes (startdate,enddate,company) {
        return Api().get('bills/getcreditnotes/'+startdate+'/'+enddate+'/'+company)
    },

    //GMW
    getb2bjsongmw (date,com) {
        return GmwApi().get('bills/getgstb2b/'+date+'/'+com)
    },

    getgstdatagmw (startdate,enddate,con) {
        return GmwApi().get('bills/getgstdata/'+startdate+'/'+enddate+'/'+con)
    },
    getcreditnotesgmw (startdate,enddate,company) {
        return GmwApi().get('bills/getcreditnotes/'+startdate+'/'+enddate+'/'+company)
    },
}